import React from "react";

const Banner = ({ heading, image }) => {
  return (
    <>
      <div className="relative">
        <img src={image} className="w-full h-[300px] object-cover" alt="" />
        <p className="flex items-center justify-center absolute inset-0 text-3xl text-white font-bold font-serif">
          {heading}
        </p>
      </div>
    </>
  );
};

export default Banner;
